import { HTML5Backend } from "react-dnd-html5-backend";
import { TouchBackend } from "react-dnd-touch-backend";
const Backend =
  navigator.userAgent.includes("iPad") || navigator.userAgent.includes("iPhone") ? TouchBackend : HTML5Backend;

export default Backend;
